import React, { useState } from 'react';
import { HttpMethod } from '../../Asset/httpMethod';
import { useDispatch } from 'react-redux';
import Loader from '../Utility/Loader';
import { startLoader, stopLoader } from '../../Redux/Slices/Utility/loaderSlice';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');

  let dispatch = useDispatch();
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      dispatch(startLoader());
      await HttpMethod.post('/Authorization/Account/ForgotPassword', { email });
      dispatch(stopLoader());
      setMsg('Password reset link sent. Check your email.');
    } catch (err) {
      setMsg(err.response?.data || 'Something went wrong');
    }
  };

  return (
    <>
      <Loader/>
      <form onSubmit={handleSubmit}>
        <div className="login-container">
          <div className="login-box">
            <h2>Forgot Password</h2>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required placeholder="Email" />
            <div className="text-center">
              <button className="savepanelBtn btn-primary ml-md-2 w-50 mt-3" type="submit">Send Reset Link</button>
            </div>
            <p>{msg}</p>
          </div>
        </div>
      </form>
    </>
  );
};

export default ForgotPassword;